<template>
    <div class="setup-plan">
      <div class="setup-plan__header">
        <h2 class="setup-plan__title">
          <v-icon left small>mdi-home-city</v-icon>
          Квартиры
        </h2>
        <div v-if="roleName === 'admin' && doorphoneModel !== 'Sokol-Plus'" class="setup-plan__actions">
          <v-menu bottom left offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="primary"
                outlined
                class="text-none"
                rounded
                v-bind="attrs"
                v-on="on"
              >
                <v-icon left>mdi-dots-horizontal</v-icon>
                Действия
              </v-btn>
            </template>
            <v-list width="320" dense>
              <v-list-item @click.prevent="syncCodes()">
                <v-list-item-icon>
                  <v-icon small>mdi-sync</v-icon>
                </v-list-item-icon>
                <v-list-item-title>
                  {{ doorphoneEditInfo.doorphone.type === 'M' ? 'Обновление универсальных кодов' : 'Синхронизация кодов с основных домофона' }}
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </div>

      <SetupPlanBeward v-if="['DKS15134', 'DKS20211'].includes(doorphoneModel)" />
      <setupPlanRubetek v-if="doorphoneModel === 'RV-3438'" />
      <setupPlanRubetekRV3434 v-if="isRv3434" />
      <SetupPlanSokol v-if="doorphoneModel === 'Sokol-Plus'" />
    </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import { headersPlan, headersPlanBeward } from '../../consts';
import SetupPlanBeward from './components/SetupPlanBeward';
import setupPlanRubetek from './components/setupPlanRubetek';
import setupPlanRubetekRV3434 from './components/setupPlanRubetekRV3434';
import SetupPlanSokol from './components/SetupPlanSokol';

export default {
  name: 'SetupPlan',
  components: { SetupPlanBeward, setupPlanRubetek, setupPlanRubetekRV3434, SetupPlanSokol },
  data: () => {
    return {
      headersPlan,
      headersPlanBeward,
    };
  },
  computed: {
    ...mapGetters({
      roleName: 'roleName',
      doorphoneEditInfo: 'Doorphone/doorphoneEditInfo',
    }),
    doorphoneModel () {
      return this.doorphoneEditInfo?.doorphone?.model || this.doorphoneEditInfo?.doorphone?.device?.model || '';
    },
    isRv3434 () {
      return this.doorphoneModel === 'RV-3434';
    },
  },
  methods: {
    ...mapActions({
      updateCodesFromDoorphone: 'Doorphone/updateCodesFromDoorphone',
      syncMainDoorphoneCodes: 'Doorphone/syncMainDoorphoneCodes',
    }),
    syncCodes () {
      const isTypeDoorphoneM = this.doorphoneEditInfo.doorphone.type === 'M';
      const action = isTypeDoorphoneM ? this.updateCodesFromDoorphone : this.syncMainDoorphoneCodes;

      action({ id: this.$route.params.id })
        .then(res => {
          if (!res.status) {
            const text = isTypeDoorphoneM ? 'Ошибка при обновление универсальных кодов' : 'Ошибка при синхронизации кодов';
            this.$flash_warning(text);
            return;
          }

          let successMessage = res.message;

          if (isTypeDoorphoneM) {
            successMessage = `${res.message}. Модель: ${res.model}, ID домофона: ${res.id}`;
          }

          this.$flash_success(successMessage);
        })
        .catch(error => {
          console.error(error);
          this.$flash_warning('Произошла ошибка во время обновления');
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.setup-plan__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 20px;
}
.setup-plan__title {
  font-size: 1rem;
  font-weight: 500;
  color: #37474f;
  margin: 0;
  display: flex;
  align-items: center;
}
.setup-plan__actions {
  flex-shrink: 0;
}
</style>
